export const AD_BANNER_DISMISSED_COOKIE = 'ad_banner_dismissed';
export const AD_BANNER_COOKIE_EXPIRES_DAYS = 4;
export const AD_BANNER_DISMISSED_ATTR = 'data-ad-banner-dismissed';

export const adBannerDismissHideCss = `html[${AD_BANNER_DISMISSED_ATTR}="1"] .ad-banner,html[${AD_BANNER_DISMISSED_ATTR}="1"] [data-ad-banner-spacer]{display:none!important;}`;

export const adBannerDismissCheckScript = `(function(){var c=document.cookie;if(c&&c.indexOf('${AD_BANNER_DISMISSED_COOKIE}=')!==-1){document.documentElement.setAttribute('${AD_BANNER_DISMISSED_ATTR}','1');}})();`;
